import * as types from './weaveTypeActionTypes';

export const getWeaveTypeRequestAction = (payload) => ({
  type: types.GET_WEAVETYPE_REQUEST,
  payload,
});
export const getWeaveTypeDataAction = (payload) => ({
  type: types.GET_WEAVETYPE_DATA,
  payload,
});
export const getWeaveTypeErrorAction = (payload) => ({
  type: types.GET_WEAVETYPE_ERROR,
  payload,
});

export const createWeaveTypeRequestAction = (payload) => ({
  type: types.CREATE_WEAVETYPE_REQUEST,
  payload,
});
export const createWeaveTypeDataAction = (payload) => ({
  type: types.CREATE_WEAVETYPE_DATA,
  payload,
});
export const createWeaveTypeErrorAction = (payload) => ({
  type: types.CREATE_WEAVETYPE_ERROR,
  payload,
});

export const updateWeaveTypeRequestAction = (payload) => ({
  type: types.UPDATE_WEAVETYPE_REQUEST,
  payload,
});
export const updateWeaveTypeDataAction = (payload) => ({
  type: types.UPDATE_WEAVETYPE_DATA,
  payload,
});
export const updateWeaveTypeErrorAction = (payload) => ({
  type: types.UPDATE_WEAVETYPE_ERROR,
  payload,
});

export const deleteWeaveTypeRequestAction = (payload) => ({
  type: types.DELETE_WEAVETYPE_REQUEST,
  payload,
});
export const deleteWeaveTypeDataAction = (payload) => ({
  type: types.DELETE_WEAVETYPE_DATA,
  payload,
});
export const deleteWeaveTypeErrorAction = (payload) => ({
  type: types.DELETE_WEAVETYPE_ERROR,
  payload,
});
